import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import UserAndRolesFormItem from 'components/CIMSFormItem/common/UserAndRolesFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { DefaultOptionType } from 'components/CIMSSelect/types'

/**
 * the modal body for FDC Approval Groups
 */
const ModalBody: React.FC<{ concurrenceLevels: DefaultOptionType[] }> = ({
  concurrenceLevels,
}) => {
  return (
    <>
      <NameFormItem help={HelpMessage.FieldDesignChanges.ApprovalGroups.Name} />
      <DescriptionFormItem entityName="Approval Group" />
      <CIMSFormItem
        name="concurrenceLevelIds"
        label="Concurrence Levels"
        help={HelpMessage.FieldDesignChanges.ApprovalGroups.ConcurrenceLevels}
      >
        <CIMSSelect options={concurrenceLevels} multiple simple />
      </CIMSFormItem>
      <UserAndRolesFormItem
        label="Approvers"
        action="approve a Field Design Change"
      />
    </>
  )
}
export default ModalBody
